import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, Form, Row, Col, Button, Spinner, InputGroup} from 'react-bootstrap';
import Swal from 'sweetalert2';
import SelecionarCategoria from '../components/Utils/SelecionarCategoria';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import { useProvider, Toast } from '../context/MenuProvider';

import AOS from "aos";
import 'aos/dist/aos.css';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const PagamentoList = () => {
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDados,
      setTitle,
    } = useProvider();
    const { tipo, modelo } = useParams(); 
    const [query, setQuery] = useState('');
    const [pagamentos, setPagamentos] = useState([]);
    const [extra, setExtra] = useState(null);
    const [status, setStatus] = useState("");
    const [filtroPagamento, setFiltroPagamento] = useState('todos');
    const [avancada, setAvancada] = useState(false);
    const [mesMenu, setMesMenu] = useState({});
    const [nextUrl, setNextUrl] = useState(null);
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [categoriaId, setCategoriaId] = useState(null);
    const [paginaDB, setPaginaDB] = useState(1);
    
    useEffect(()=>{
      if(!modelo) setTitle("Receitas e Despesas");
      if(modelo === "despesa"){
        const tipos = tipo.split(",");
        setTitle("Pagamentos");
        //setCategoriaId(tipos.length === 0 ?[]:tipos);
      }
      if(modelo === "receita"){
        setFiltroPagamento(tipo);
        setTitle("Recebimentos");
      }
    },[modelo])
    

    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const receita = queryParams.get('receita')?.toLowerCase() || null;
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    }, []);

    const carregarMesMenu = (deslocamento = 0) => {
      const [ ano, mes, dia ] = dataInicio.split('-')
      const data = dataInicio ? new Date(ano, parseInt(mes)-1) : new Date();
 
      data.setMonth(data.getMonth() + deslocamento);
      
      // Obtém o nome do mês atual
      const mesAtual = data.toLocaleString('default', { month: 'long' });
    
      // Configura os valores do menu
      setMesMenu({
        anterior: new Date(data.getFullYear(), data.getMonth() - 1).toLocaleString('default', { month: 'long' }),
        atual: `${mesAtual}/${data.getFullYear()}`,
        proximo: new Date(data.getFullYear(), data.getMonth() + 1).toLocaleString('default', { month: 'long' }),
      });
    
      // Define a data inicial e final do mês atual
      setDataInicio(new Date(data.getFullYear(), data.getMonth(), 1).toLocaleDateString('sv-SE'));
      setDataFim(new Date(data.getFullYear(), data.getMonth() + 1, 0).toLocaleDateString('sv-SE')); // Último dia do mês
    };
    

    useEffect(()=>{
      if(!avancada) carregarMesMenu();
    }, [avancada, setDataInicio, setDataFim]);
    
    const { get, loading } = crud || {};
  
    const isConsultaCarregada = useRef(false);
    const buscarPagamentosLocal = async (novaBusca = false) =>{
      try{
        //alert(`Inicio: ${dataInicio}\nFim: ${dataFim}\nPagina: ${paginaDB}`);
        if(novaBusca){
          setPagamentos([]);
        } else if(paginaDB === 0) return;
        
        
        const response = await buscarDados(
          "db_pagamentos",
          (item) =>{
            const dataItem = new Date(item.data_do_pagamento).getTime();
            const dataIn = new Date(dataInicio).getTime();
            const hoje = new Date(new Date().toLocaleDateString('sv-SE')).getTime();
            const dataOut = new Date(dataFim).getTime();
            const periodos = (dataInicio && dataFim)
                ? dataItem >= dataIn && dataItem <= dataOut
                : (dataInicio) ? dataItem >= dataIn : (dataFim) ? dataItem <= dataOut : true;
                
            let filtrosAvancados = true;    
            let tipo = false;    
            switch(modelo){
              case `receita`:
                if (filtroPagamento === 'pago') filtrosAvancados = item.pago;
                else if (filtroPagamento === 'atrasado') filtrosAvancados = !item.pago && dataItem < hoje;
                //else if (filtroPagamento === 'calotes') url += `&atrasado=true&status_ativo=false`;
                else if (filtroPagamento === 'vencer') filtrosAvancados = !item.pago && dataItem >= hoje;
                else if (filtroPagamento === 'aberto') filtrosAvancados = !item.pago;
                tipo = !!item.venda?.id;
                break;
              case `despesa`:
                // if (categoriaId){
                //   switch(categoriaId){
                //     case "pessoais":
                //       filtrosAvancados = item.tipo === categoriaId;
                //       break;
                //     case "negocio":
                //       url += `&tipo=${categoriaId}`;
                //       break;
                //     default:
                //       url += `&categoria_ids=${categoriaId}`;
                //       break;
                //   }
                // }
                // if (status){
                //   switch(status){
                //     case "pago":
                //       url += `&pago=true`;
                //       break;
                //     case "atrasado":
                //       url += `&atrasado=true&status_ativo=true`;
                //       break;
                //     case "proximos":
                //       url += `&pago=false&atrasado=false`;
                //       break;
                //     case "aberto":
                //       url += `&pago=false`;
                //       break;
                //   }
                // }
                tipo = !!item.financeiro;
                break;
            }
            
            
            return tipo && periodos && filtrosAvancados;
          },
          15,
          "data_do_pagamento",
          "desc",
          paginaDB,
        );
        if (isConsultaCarregada.current) return;
        if (response && response.length){
          if(novaBusca){
            setPagamentos(response);
            setPaginaDB(1);
          }else{
            setPagamentos((prev) => {
              const novos = Array.isArray(response) ? response : [response];
            
              const filtrados = novos.filter(
                (item) => !prev.some((p) => p.id === item.id)
              );
            
              return [...prev, ...filtrados];
            });
            setPaginaDB(paginaDB+1);
          }
        }else{
          setPaginaDB(0);
        }
      }catch(err){
        
      }finally{

      }
    }
    
    // Função para buscar pagamentos na API
    
    const buscarPagamentos = async (novaBusca = false) => {
        let url = `/gvendas/pagamentos/?ordering=-data_do_pagamento,pago`;
        if (query) url += `&search=${query}`;
        const agora = new Date().toLocaleDateString('sv-SE')
        
        let expand = ``;
        let filter = ``;
        if (status){
            switch(status){
                case "pago":
                  url += `&pago=true`;
                  if (dataInicio) url += `&data_do_pagamento__gte=${dataInicio}`;
                  if (dataFim) url += `&data_do_pagamento__lte=${dataFim}`;
                  break;
                case "atrasado":
                  if (dataInicio) url += `&data_do_pagamento__gte=${dataInicio}`;
                  url += `&data_do_pagamento__lt=${agora}&pago=false`;
                  break;
                case "proximos":
                  url += `&data_do_pagamento__gte=${agora}&pago=false`;
                  if (dataFim) url += `&data_do_pagamento__lte=${dataFim}`;
                  break;
                case "aberto":
                  url += `&pago=false`;
                  if (dataInicio) url += `&data_do_pagamento__gte=${dataInicio}`;
                  if (dataFim) url += `&data_do_pagamento__lte=${dataFim}`;
                  break;
            }
        }
        else{
          if (dataInicio) url += `&data_do_pagamento__gte=${dataInicio}`;
          if (dataFim) url += `&data_do_pagamento__lte=${dataFim}`;
        }
        
        if(modelo === "receita"){
            url += `&venda__isnull=false&financeiro__isnull=true`
            expand =`venda,cliente`;
            filter = `venda,cliente,nome,ativo`;
            if (filtroPagamento === 'pago') url += `&pago=true`;
            else if (filtroPagamento === 'atrasado') url += `&data_do_pagamento__lt=${agora}&pago=false&venda__cliente__ativo=true`;
            else if (filtroPagamento === 'calotes') url += `&data_do_pagamento__lt=${agora}&pago=false&venda__cliente__ativo=false`;
            else if (filtroPagamento === 'vencer') url += `&pago=false&data_do_pagamento__gte=${agora}`;
            else if (filtroPagamento === 'aberto') url += `&pago=false`;
        }
        if(modelo === "despesa"){
            //alert(categoriaId)
            url += `&financeiro__isnull=false&venda__isnull=true&financeiro__categoria__in=${categoriaId||''}&financeiro__categoria__tipo__in=${tipo||'pessoais,negocio'}`;
            expand =`financeiro,categoria`;
            filter =`financeiro,categoria,nome,observacoes,tipo`;
        }
        if(!modelo){
            expand =`venda,cliente,financeiro,categoria`;
            filter=`venda,cliente,nome,ativo,financeiro,categoria,observacoes,tipo`
        }
        url += `&expand=${expand}${(dataFim && dataFim)?',extra':''}`
        url += `&filtros=forma_de_pagamento,data_do_pagamento,valor_total,pago,id,${filter}`

        if (novaBusca) {
            //setPagamentos([]);
            setNextUrl(null);
            //setExtra(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url || modelo === null) return;
        // alert(url)
        // window.location = `https://develop.gvendas.app.br${url}`
        try{
          const response = await get(url, 'pagina');
          if (response && response.length){
            const novosItens = response[0].results;
            isConsultaCarregada.current = true;
            //alert(JSON.stringify(novosItens))
            setPagamentos((pagamentosAnteriores) => {
              if (novaBusca) return novosItens;
            
              const mapa = new Map();
            
              [...pagamentosAnteriores, ...novosItens].forEach(item => {
                mapa.set(item.id, item); // substitui se já existir
              });
            
              return Array.from(mapa.values());
            });
            setExtra(response[0]?.extra?.total);
            setNextUrl(response[0].next);
          } else{
            setPagamentos([]);
            setNextUrl(null);
            setExtra(null);
          }
          
        }catch(err){
          setNextUrl(null);
          setExtra(null);
          ///
          // Toast.fire({
          //   icon: "error",
          //   title: "Falha ao buscar pagamentos"
          // });
        }finally{
          
        }
    };
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar produtos', to: '/estoque/sincronizar' },
        ...(modelo==="despesa" ? [
          { name: 'Nova categoria de Despesas Pessoais', to: '/categorias/novo?tipo=pessoais' },
          { name: 'Nova categoria de Custos do Negócio', to: '/categorias/novo?tipo=negocio' },
          { name: 'Nova despesa', to: '/despesas/novo' },
        ]:[
          { name: 'Nova categoria de Produtos', to: '/categorias/novo?tipo=produtos' },
          { name: 'Nova receita/venda', to: '/checkout/selecionar-cliente' },
        ]),
      ]);
      
      setBtns([
        {icon:'bi-funnel'+(avancada?'-fill':''), to:`?modelo=${modelo}`, onClick:() => {setAvancada(!avancada); setFiltroPagamento('todos');setDataInicio('');setDataFim('');}},
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns, avancada, setAvancada]);
    
    const buscarGeral = (novaBusca = false) => {
      buscarPagamentosLocal(novaBusca);
      buscarPagamentos(novaBusca);
    }

    // Carrega todos os pagamentos ao montar o componente ou ao aplicar um novo filtro
    useEffect(() => {
      buscarGeral(true);
    }, [query, filtroPagamento, setDataInicio, dataInicio, dataFim, mesMenu, categoriaId, status, modelo]);

    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                //if (!loading) buscarPagamentos();
                if (!loading) buscarGeral();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading, paginaDB, dataInicio, dataFim, filtroPagamento]);
    
    

    const realizarNovaBusca = () => {
        //buscarPagamentos(true);
        buscarGeral(true);
    };
    
    const getColor = (data, pago, obj) => {
      const dataPagamento = dayjs(data).startOf('day');
      const hoje = dayjs().startOf('day');
  
      if (pago) return 'green';
      if (dataPagamento.isSame(hoje)) return 'orange';
      if (dataPagamento.isBefore(hoje)) return 'red';
      if (dataPagamento.isBefore(hoje)) return 'red';
      if (!obj?.venda?.cliente?.ativo && !obj.financeiro) return 'black';
      return 'inherit';
    };
    
    const realizarNovoCarregamento = () => {
        //buscarPagamentos(false);
        buscarGeral(false);
    };
    
    const pagamentosAgrupadas = pagamentos.reduce((acc, venda) => {
      const data = dayjs(venda.data_do_pagamento).format("DD/MM/YYYY dddd"); // Assumindo que data_da_venda está no formato desejado
      if (!acc[data]) {
        acc[data] = [];
      }
      acc[data].push(venda);
      return acc;
    }, {});

    return (
      <>
        <MenuRodape total={extra} />
        <BotaoFlutuante
          to={modelo === "receita" ? `/checkout/selecionar-cliente` : `/despesas/novo?tipo=${tipo === "todos"?'pessoais,negocio':tipo}`}
          icon="bi-plus"
          posicao={parseFloat(extra || 0) > 0 ? `2` : `1`}
        />
    
        <div>
          <Form>
            {avancada && (
              <Form.Group controlId="formBasicSearch">
                <Form.Control
                  type="text"
                  placeholder="Digite a pesquisa"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </Form.Group>
            )}
    
            {!avancada && (
              <Row className="align-items-center">
                <Col onClick={() => carregarMesMenu(-1)}>{mesMenu.anterior}</Col>
                <Col className="text-center fs-4">{mesMenu.atual}</Col>
                <Col className="text-end" onClick={() => carregarMesMenu(1)}>
                  {mesMenu.proximo}
                </Col>
              </Row>
            )}
    
            {modelo === "despesa" && (<>
                <SelecionarCategoria defaultText={` `} multiplos={true} tipo={tipo} categoriaId={categoriaId || []} setCategoriaId={setCategoriaId} label="Tipo"/>
                <InputGroup className="mt-3" size="sm">
                    <span className="input-group-text">
                      Status
                    </span>
                    <Form.Control
                      as="select"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="">Todos</option>
                      <option value="pago">Pago</option>
                      <option value="aberto">Aberto</option>
                      <option value="proximos">Próximos</option>
                      <option value="atrasado">Atrasado</option>
                    </Form.Control>
                </InputGroup>
            </>)}
    
            {modelo === "receita" && (
              <Form.Group controlId="formSelectFilter" className="mt-3">
                <div className="input-group">
                  <span className="input-group-text">Status</span>
                  <Form.Control
                    as="select"
                    id="formSelectStockFilter"
                    value={filtroPagamento}
                    onChange={(e) => setFiltroPagamento(e.target.value)}
                  >
                    <option value="todos">Todos</option>
                    <option value="aberto">Em aberto</option>
                    <option value="vencer">Próximos</option>
                    <option value="pago">Pago</option>
                    <option value="atrasado">Atrasado</option>
                    <option value="calotes">Calotes</option>
                  </Form.Control>
                  {!avancada && (
                    <Button
                      variant="secondary"
                      onClick={() => buscarGeral(true)}
                    >
                      <i className="bi bi-search"></i>
                    </Button>
                  )}
                </div>
              </Form.Group>
            )}
    
            {avancada && (
              <>
                <Form.Group controlId="formDateRange" className="mt-3">
                  <Form.Label>Período</Form.Label>
                  <div className="input-group">
                    <span className="input-group-text">De</span>
                    <Form.Control
                      type="date"
                      value={dataInicio}
                      onChange={(e) => setDataInicio(e.target.value)}
                    />
                    <span className="input-group-text">até</span>
                    <Form.Control
                      type="date"
                      value={dataFim}
                      onChange={(e) => setDataFim(e.target.value)}
                    />
                  </div>
                </Form.Group>
    
                <Button
                  variant="secondary"
                  onClick={realizarNovaBusca}
                  className="mt-2 w-100"
                >
                  Buscar
                </Button>
              </>
            )}
          </Form>
          
          <div className="list-group mt-3">
            {Object.entries(pagamentosAgrupadas).length > 0 ? (
              Object.entries(pagamentosAgrupadas).map(([data, pagamentosDoDia]) => (
                <div key={data}>
                  <div className="text-muted mt-2">{data}</div>
                  {pagamentosDoDia.map((x) => (
                    <RenderizarProduto
                      key={x.id}
                      to={
                        x.venda
                          ? `/vendas/${x.venda?.id || x.venda}/${x.id}`
                          : `/despesas/editar/${parseInt(x.financeiro?.id || x.financeiro)}/${x.financeiro?.categoria?.tipo||``}`
                      }
                      lm="mb-1"
                      col="d-none"
                      col2="col-auto text-end"
                      text1={x.venda?.cliente?.nome || x.financeiro?.categoria?.nome || ``}
                      titulo3={parseFloat(x.valor_total).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                      text2={
                        x.venda
                          ? `Pagamento em ${x.forma_de_pagamento}`
                          : x.financeiro?.observacoes || ``
                      }
                      bcolor={
                        getColor(x.data_do_pagamento, x.pago, x)
                      }
                      text3={
                        x.pago ? (x.venda ? "recebido" : "pago") : x.venda ? "receber" : "pagar"
                      }
                    />
                  ))}
                </div>
              ))
            ) : (
              !loading && (
                <p data-aos="fade-up" className="text-center text-muted">
                  Nenhum pagamento encontrado.
                </p>
              )
            )}
    
            {loading && (
              <p data-aos="fade-up" className="text-center">
                <Spinner animation="border" />
              </p>
            )}
    
            {!loading && nextUrl && (
              <Button
                variant="secondary"
                data-aos="fade-up"
                onClick={() => buscarGeral(false)}
                className="mt-2"
              >
                Buscar mais...
              </Button>
            )}
          </div>
        </div>
      </>
    );
};

const MenuRodape = ({ total }) => {
  if (parseFloat(total || 0)<=0) return null;

  return (
    <div className="bs-floating shadow navbar-light">
      <div className="container py-1">
        <div className="row align-items-center">
          <div className="text-end">
            Valor total {' '} 
            <span className="fs-4">
              {parseFloat(total||0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagamentoList;